var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgListView = function SvgListView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#list-view_svg__a)",
    fill: "#F1892B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.393 11.536H4.743v1.228h12.65v-1.228ZM2.403 13.604a1.454 1.454 0 1 0 0-2.908 1.454 1.454 0 0 0 0 2.908ZM17.393 1.175H4.743v1.228h12.65V1.175ZM2.403 3.243a1.454 1.454 0 1 0 0-2.908 1.454 1.454 0 0 0 0 2.908ZM17.393 6.355H4.743v1.229h12.65V6.355ZM2.403 8.423a1.454 1.454 0 1 0 0-2.907 1.454 1.454 0 0 0 0 2.907Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "list-view_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.95 .335)",
    d: "M0 0h16.443v13.273H0z"
  })))));
};
export default SvgListView;